import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function PolicemanIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.3333 11.6668C15.3114 12.6524 16.6667 14.709 16.6667 17.5002V19.1668H3.33333V17.5002C3.33333 14.7049 4.69257 12.6464 6.66667 11.6668M14.9193 5.8335C15.1008 6.35502 14.9193 6.91628 14.9193 7.50098C14.9193 10.262 12.7169 12.5002 10 12.5002C7.28146 12.5002 5.07765 10.262 5.07765 7.50098C5.07765 6.92803 4.90294 6.34609 5.07765 5.8335M5 6.66683H15L17.5 3.3335C15.907 1.88797 13.1587 0.833496 10 0.833496C6.80304 0.833496 4.02655 1.91364 2.5 3.3335L5 6.66683ZM10 4.16683C10.4602 4.16683 10.8333 3.79373 10.8333 3.3335H9.16667C9.16667 3.79373 9.53976 4.16683 10 4.16683Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </IconWrapper>
  )
}
